import { Component, computed, inject, input } from '@angular/core';
import { CrmObject } from '@vendasta/crm';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { CrmFieldService } from '@galaxy/crm/services/field-service';
import { getFormattedContactDisplayName } from '../../../users.utility';
import { toObservable } from '@angular/core/rxjs-interop';
import { MeetingAnalysisRouterService } from '@galaxy/meeting-analysis/static';
import { Observable, of, switchMap } from 'rxjs';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'meeting-analysis-participant',
  templateUrl: './participant.component.html',
  styleUrls: ['./participant.component.scss'],
  imports: [CommonModule, MatCardModule, GalaxyAvatarModule, RouterLink],
})
export class ParticipantComponent {
  protected fieldsService = inject(CrmFieldService);
  protected routerService = inject(MeetingAnalysisRouterService);

  contact = input<CrmObject>();
  name = input<string>();
  suffix = input<string>('');
  linkToContactPage = input<boolean>(true);
  shape = input<'circle' | 'square'>('circle');
  large = input<boolean>(false);
  profilePictureUrl = computed(() => {
    // const contact = this.contact();
    return ''; // Contacts don't have a profile picture yet;
  });

  profileUrl$: Observable<string> = toObservable(this.contact).pipe(
    switchMap((contact) =>
      contact ? this.routerService.applyRoutePrefix(`/crm/contact/profile/${contact.crmObjectId}`) : of(''),
    ),
  );

  displayName = computed(() => {
    const contact = this.contact();
    if (contact) {
      return getFormattedContactDisplayName(contact, this.fieldsService);
    }
    return this.name();
  });
}
